export default __webpack_public_path__ + "static/media/03.ad10de08.jpg";